import {UserCheck01Icon} from '@/components/ui/icon/Icon'
import {MenuItem} from '@/components/ui/menu-atoms/MenuAtoms'
import {MarkAsTrasmittedDialog} from '@/features/projects/components/mark-as-transmitted-dialog/MarkAsTransmittedDialog'
import {ProjectIndex} from '@/features/projects/types'
import {useTranslation} from '@/translations/i18n'

export const ProjectOptionMarkAsTransmittedMenuItem = ({project}: {project: ProjectIndex}) => {
    const {t} = useTranslation()

    if (!project.status || !project.progressStatus) {
        return null
    }

    if (project.progressStatus == 'to_transmit' && project.status != 'closed' && !!project.openingTransmissionAt) {
        return (
            <MenuItem disabled>
                <UserCheck01Icon /> {t('projects:mark_siar_transmission_done')}
            </MenuItem>
        )
    }

    return (
        <MarkAsTrasmittedDialog
            statuses={[project.status]}
            progressStatuses={[project.progressStatus]}
            isOpeningTransmissionDone={project.openingTransmissionAt != null}
            projectIds={[project.id]}
            customTrigger={({onClick, isDisabled}) => (
                <MenuItem
                    disabled={isDisabled}
                    onClick={e => {
                        e.preventDefault()
                        onClick(e)
                    }}
                >
                    <UserCheck01Icon />
                    {t('projects:mark_siar_transmission')}
                </MenuItem>
            )}
        />
    )
}
